import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar,
} from "@material-ui/core";
import { Alert } from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteCategoryAction } from "../../../redux/coupon/DeleteCategoryRTK";
import { getCategoryAction } from "../../../redux/coupon/GetCategoryRTK";

export default function DeleteCategory({
  deleteCategory,
  setDeleteCategory,
  propsData,
}) {

  // console.log("propsData",propsData)
  const dispatchRTK = useDispatch();
  const deleteCategoryRTK = useSelector((state) => state.deleteCategory);
  const { data, status, message, error } = deleteCategoryRTK;
  const [snackbarState, setSnackbarState] = useState(false)


  // function -->
  const handleClose = () => {
    setDeleteCategory(false);
  };
  const deleteCategoryFunc = () => {
    dispatchRTK(deleteCategoryAction(propsData));
    if (data?.status_code == 200) {
      setDeleteCategory(false);
    }
    setSnackbarState(true)
  };

  const snackBarClose = () => {
    setSnackbarState(false)
    setDeleteCategory(false)
  }

  return (
    <>
      <Dialog
        open={deleteCategory}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Delete Category</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete your Category ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={deleteCategoryFunc}>
            Delete
          </Button>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>



      {/* snackbar */}
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackbarState} autoHideDuration={1000} onClose={snackBarClose}>
        <Alert onClose={snackBarClose} severity={status == 200 ? "success" : "error"} sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Snackbar>
    </>
  );
}
